import React from 'react'
import { connect } from 'react-redux'
import Notifications from './Notifications'

export default (o) => {
return(
    <div style={{position:"relative", left: "0px", width: o.rightStackOpened?"50vw":"95vw"}}>
      <Notifications />
	  {o.addEnt &&
		  <span
              style={{
                  position: "absolute"
                , right: "100px"
                , marginTop: "15px"
                , height: "24px"
                , lineHeight: "24px"
                , cursor: "pointer"
              }}
              onClick={o.addEntFunc}
          >
              <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  style={{
                      verticalAlign: "middle"
                  }}
              >
                  <title>Group 2</title>
                  <defs></defs>
                  <g
                      id="Page-1"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                  >
                      <g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
                          <path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
                          <path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
                          <circle id="Oval-1" cx="11" cy="11" r="11"></circle>
                      </g>
                  </g>
              </svg>
              <span
                  style={{
                      verticalAlign: "middle"
                    , marginLeft: "10px"
                  }}
              >
                  {o.addEntText}
              </span>
          </span>
	  }
    </div>
)
}



// WEBPACK FOOTER //
// ./src/components/ListLayoutParts/ActionBar.js